import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("是");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("否");

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px",
    "color": "#999",
    "line-height": "1.4"
  }
}, "业务员在万药通进行商品加购时可进行改价，修改价格不得低于最低销售价", -1);

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("确认");

import { computed, reactive, ref, watch } from 'vue';
import { updateBottomPrice } from '@/request';
import { ElMessage } from 'element-plus/lib/components';
export default {
  name: 'UpdateBottomPriceModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      default: ''
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const priceEditDisabled = computed(() => {
      return props.data.priceSyncStrategy == 1;
    });
    const salePriceShow = computed(() => {
      let {
        priceSyncStrategy,
        dsSalePrice
      } = props.data;

      if (priceSyncStrategy == 2) {
        return true;
      }

      if (dsSalePrice == 0) {
        return true;
      }

      return false;
    });
    let form = ref({
      isUpdate: 0,
      bottomPrice: 0,
      memberPrice: 0,
      dsSalePrice: 0
    });
    let formRef = ref();
    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        form.value = {};
      }

      if (newVal && props.data) {
        formRef.value.resetFields();
        form.value = {
          isUpdate: props.data.isModifyPrice,
          bottomPrice: props.data.bottomPrice,
          memberPrice: props.data.memberPrice,
          dsSalePrice: props.data.dsSalePrice
        };
      }
    }, {
      flush: 'post'
    });

    function confirm() {
      formRef.value.validate(e => {
        if (e) {
          let payload = {
            supMerchandiseId: props.data.merchandiseId,
            supplierId: props.supplierId,
            prodNo: props.data.prodNo,
            isModifyPrice: form.value.isUpdate
          };

          if (props.data.priceSyncStrategy == 2) {
            payload.bottomPrice = form.value.bottomPrice || 0;
            payload.salePrice = form.value.memberPrice;

            if (payload.isModifyPrice == 1 && (payload.bottomPrice == 0 || payload.bottomPrice > payload.salePrice)) {
              ElMessage.error('最低销售价必须大于0，小于销售价');
              return;
            }
          }

          updateBottomPrice(_objectSpread(_objectSpread({}, payload), {}, {
            __repeat: true,
            __warn: true
          })).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              visible.value = false;
              emit('success', form);
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        "z-index": "1000",
        title: "编辑商品最低销售价",
        width: "700px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(form)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.prodName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品规格"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.prodSpecification), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "生产厂家"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.manufacturer), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "支持业务员在万药通进行商品改价",
            prop: "isUpdate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).isUpdate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).isUpdate = $event),
              style: {
                "position": "relative",
                "top": "-3px"
              },
              disabled: _unref(priceEditDisabled)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1,
                size: "large"
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0,
                size: "large"
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue", "disabled"]), _hoisted_3]),
            _: 1
          }), _unref(salePriceShow) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "销售价",
            prop: "memberPrice"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(form).memberPrice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).memberPrice = $event),
              precision: 2,
              min: 0,
              max: 9999999,
              disabled: _unref(priceEditDisabled)
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "最低销售价",
            prop: "bottomPrice"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: _unref(form).bottomPrice,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).bottomPrice = $event),
              precision: 2,
              min: 0,
              max: 9999999,
              disabled: _unref(priceEditDisabled)
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "个性化定价（仅支持ERP同步个性化定价方案）"
          }), _createVNode(_component_el_table, {
            data: __props.data.merchandiseErpPriceList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "价格类型",
              prop: "priceTypeName"
            }), _createVNode(_component_el_table_column, {
              label: "销售价",
              prop: "salePrice"
            }), _createVNode(_component_el_table_column, {
              label: "线下客户类型",
              prop: "erpCustTypeName"
            }), _createVNode(_component_el_table_column, {
              label: "平台客户类型",
              prop: "wycCustTypeName"
            })]),
            _: 1
          }, 8, ["data"])], 64))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};